class ProductTrustActions extends HTMLElement {
  connectedCallback() {
    this.#whatsappLink = this.querySelector('[data-whatsapp-order]');
    this.#whatsappLink?.addEventListener('click', this.#handleWhatsAppClick);

    const section = this.closest('.shopify-section');
    section?.addEventListener('variant:update', this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    this.#whatsappLink?.removeEventListener('click', this.#handleWhatsAppClick);

    const section = this.closest('.shopify-section');
    section?.removeEventListener('variant:update', this.#handleVariantUpdate);
  }

  /** @type {HTMLAnchorElement | null} */
  #whatsappLink = null;

  /** @param {Event} event */
  #handleVariantUpdate = (event) => {
    const link = this.#whatsappLink;
    if (!link || !(event instanceof CustomEvent)) return;

    const variant = event.detail?.resource;
    if (variant?.title) {
      link.dataset.variantTitle = variant.title;
    }

    const priceContainer = this.closest('.product-information')?.querySelector('[ref="priceContainer"]');
    if (priceContainer?.textContent) {
      link.dataset.productPrice = priceContainer.textContent.trim().replace(/\s+/g, ' ');
    }
  };

  /**
   * Digits-only international phone for wa.me (e.g. 905303522838).
   * @param {string | undefined} value
   * @returns {string}
   */
  #normalizePhone(value) {
    let digits = String(value || '').replace(/\D/g, '');

    if (digits.length === 11 && digits.startsWith('0')) {
      digits = `90${digits.slice(1)}`;
    } else if (digits.length === 10 && digits.startsWith('5')) {
      digits = `90${digits}`;
    }

    return digits;
  }

  /** @param {MouseEvent} event */
  #handleWhatsAppClick = (event) => {
    event.preventDefault();

    const link = this.#whatsappLink;
    const phone = this.#normalizePhone(this.dataset.phone);

    if (!link || !phone) return;

    const lines = [];

    if (this.dataset.messageIntro) {
      lines.push(this.dataset.messageIntro);
      lines.push('');
    }

    if (link.dataset.productTitle) {
      lines.push(`Ürün: ${link.dataset.productTitle}`);
    }

    if (this.dataset.includeVariant === 'true' && link.dataset.variantTitle && link.dataset.variantTitle !== 'Default Title') {
      lines.push(`Seçenek: ${link.dataset.variantTitle}`);
    }

    if (link.dataset.productPrice) {
      lines.push(`Fiyat: ${link.dataset.productPrice}`);
    }

    if (link.dataset.productUrl) {
      lines.push(`Link: ${link.dataset.productUrl}`);
    }

    if (this.dataset.includeDelivery === 'true') {
      const deliveryLines = this.#getDeliveryDetails();

      if (deliveryLines.length) {
        lines.push('');
        lines.push('Teslimat bilgileri:');
        deliveryLines.forEach((line) => lines.push(`- ${line}`));
      }
    }

    const message = lines.join('\n');
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  /** @returns {string[]} */
  #getDeliveryDetails() {
    const details = [];
    const section = this.closest('.product-information, [data-testid="product-information-details"]') ?? document;
    const seen = new Set();

    section.querySelectorAll('[name^="properties["]').forEach((field) => {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
      if (!field.value.trim()) return;

      const match = field.name.match(/^properties\[(.+)\]$/);
      const label = match?.[1] ?? field.name;
      const line = `${label}: ${field.value.trim()}`;

      if (seen.has(line)) return;
      seen.add(line);

      details.push(line);
    });

    return details;
  }
}

if (!customElements.get('product-trust-actions')) {
  customElements.define('product-trust-actions', ProductTrustActions);
}
